// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2LTID","content":"LayoutSettings_content__InFrc"};